export type Voidable = undefined | null;

export function isVoid<T>(value: T | Voidable): value is Voidable {
  return value === null || value === undefined;
}
